<template>
  <div class="page">
    <div class="div-header-select">
      <div class="div-center">
        <div class="div-title">账单筛选：</div>
        <el-select
          v-model="state"
          placeholder="账单状态"
          size="medium"
          style="width: 320px"
        >
          <el-option v-for="item in stateList" :key="item" :label="item"  :value="item" >
          </el-option>
        </el-select>
        <el-select
          v-model="queryPricing"
          placeholder="收费项目"
          multiple
          size="medium"
          style="width: 320px; margin-left: 5px"
          clearable
          @clear="initQuery"
        >
          <el-option  v-for="item in pricingList"  :key="item.id"  :label="item.name"  :value="item.value"  >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="div-header-select div-2-top">
      <div class="div-center">
        <div class="div-title"></div>
        <el-date-picker
          style="width: 320px"
          size="medium"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="账单开始日期"
          end-placeholder="账单结束日期"
        >
        </el-date-picker>
        <el-date-picker
          style="margin-left: 5px; width: 320px"
          size="medium"
          v-model="daterangePaid"
          type="daterange"
          range-separator="至"
          start-placeholder="支付开始日期"
          end-placeholder="支付结束日期"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="div-header-select div-2-top">
      <div class="div-center">
        <div class="div-title">房源筛选：</div>
        <el-cascader
          clearable
          @clear="initQuery"
          size="medium"
          :props="areaProps"
          v-model="areaIDSelect"
          style="width: 320px"
        ></el-cascader>
        <el-input
          @keyup.enter.native="initQuery"
          placeholder="房号"
          v-model="houseNameRegex"
          clearable
          maxlength="11"
          @clear="initQuery"
          size="medium"
          style="margin-left: 5px; width: 320px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="div-header-select div-2-top">
      <div class="div-center">
        <div class="div-title">人员筛选：</div>
        <el-input
          @keyup.enter.native="initQuery"
          style="width: 320px"
          placeholder="姓名或手机号"
          v-model="nameOrPhone"
          clearable
          maxlength="13"
          @clear="initQuery"
          size="medium"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="div-header-select div-export">
      <div class="div-center">
        <el-button
          type="primary"
          size="medium"
          @click="payTogether"
          style="z-index: 30"
          >合并缴费</el-button
        >
      </div>
      <div class="div-center">
        <el-button
          type="primary"
          size="medium"
          @click="electricityBillExport"
          style="z-index: 30"
          >导出电费报表</el-button
        >
      </div>
      <div class="div-center">
        <el-button
          type="primary"
          size="medium"
          @click="exportFile"
          style="z-index: 30"
          >导出报表</el-button
        >
      </div>
      <div class="div-center" style="margin-left: 10px; z-index: 30">
        <el-button type="primary" size="medium" @click="showDialogUpload"
          >导入付款信息</el-button
        >
      </div>
      <!-- <div class="div-center">
        <span>付款二维码：</span>
        <el-button
          size="medium"
          @click="showQR"
          :disabled="billIdList.length === 0"
          >获取二维码</el-button
        >
      </div>

      <div class="div-center" style="margin-left: 85px">
        <span>报表：</span>
        <el-checkbox-group v-model="exportType">
          <el-checkbox label="账单明细"></el-checkbox>
          <el-checkbox label="房源汇总"></el-checkbox>
        </el-checkbox-group>
      </div>
      <el-button size="medium" @click="exportFile" style="margin-left: 15px"
        >导出报表</el-button
      >

      <div class="div-center" style="margin-left: 85px">
        <span>付款信息：</span>
        <el-button size="medium" @click="showDialogUpload">导入</el-button>
      </div> -->
    </div>

    <div id="myChart" class="div-header-select">
      <el-card class="box-card" style="width: 210px">
        <div slot="header">
          <span>应收金额（元）</span>
        </div>
        <countTo
          class="text item"
          :startVal="0"
          :endVal="statistics.total / 100"
          :duration="1000"
          :decimals="2"
          prefix="¥ "
        ></countTo>
      </el-card>
      <el-card class="box-card" style="width: 210px; margin-left: 50px">
        <div slot="header">
          <span>实收金额（元）</span>
        </div>
        <countTo
          class="text item"
          :startVal="0"
          :endVal="statistics.paid / 100"
          :duration="1000"
          :decimals="2"
          prefix="¥ "
        ></countTo>
      </el-card>
      <el-card class="box-card" style="width: 210px; margin-left: 50px">
        <div slot="header">
          <span>待缴金额（元）</span>
        </div>
        <countTo
          class="text item"
          :startVal="0"
          :endVal="statistics.unpaid / 100"
          :duration="1000"
          :decimals="2"
          prefix="¥ "
        ></countTo>
      </el-card>
    </div>

    <main style="margin-top: 25px">
      <el-tabs v-model="queryType" type="card">
        <el-tab-pane label="账单明细" name="账单明细">
          <el-table ref ="payRef"  @sort-change="sortChange" height="calc(100vh - 335px)"  :data="listData"  style="width: 100%"  @selection-change="handleSelectionChange" >
            <template slot="empty">
              <img src="../../assets/list-none.png" alt="" width="400"  class="table-empty"  />
              <div>空荡荡的～暂无数据！</div>
            </template>
            <el-table-column  :selectable="handleSelection" type="selection" width="55"  >
            </el-table-column>

            <el-table-column label="房源" width="190px" align="center">
              <template slot-scope="scope">
                <el-popover  placement="top-start" width="400px" trigger="click"  >
                  <div>{{ scope.row.areaName  ? scope.row.areaName + "：" + scope.row.houseName : scope.row.houseName  }}</div>
                  <div slot="reference" class="name-wrapper">
                    <el-tag style="cursor: pointer" size="medium">{{
                        scope.row.areaName ? scope.row.areaName + "：" + scope.row.houseName  : scope.row.houseName
                      }}
                    </el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="承租人" align="center">
              <template slot-scope="scope">
                <el-popover placement="top-start"  content="test"  width="400px" trigger="click" >
                  <el-table :data="scope.row.renters">
                    <el-table-column  width="150" property="realname" label="姓名" ></el-table-column>
                    <el-table-column  width="150"  property="phone"  label="电话"  ></el-table-column>
                  </el-table>
                  <div slot="reference" class="name-wrapper">
                    <el-tag style="cursor: pointer" size="medium">{{
                      scope.row.renters ? scope.row.renters[0].realname : ""
                    }}</el-tag>
                  </div> 
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="pricingName" label="收费项目" align="center">
            </el-table-column>
            <el-table-column prop="billStartStr" sortable="custom"  label="开始时间" align="center" >
            </el-table-column>
            <el-table-column prop="billEndStr" label="结束时间" align="center">
            </el-table-column>
            <!-- :filters="[{text: '生效中', value: '生效中'}, {text: '未生效', value: '未生效'}, {text: '已过期', value: '已过期'}, {text: '已作废', value: '已作废'}]"
            :filter-method="filterHandler" -->
            <el-table-column prop="leaseState" label="合同状态" align="center">
            </el-table-column>
            <el-table-column label="应收金额(元)" align="right">
              <template slot-scope="scope">
                <strong>{{ numFormat(scope.row.totalAmountStr) }}</strong>
              </template>
            </el-table-column>
            <el-table-column label="实收金额(元)" align="right">
              <template slot-scope="scope">
                <strong
                  :style="{
                    color: scope.row.paidAmountStr > 0 ? '#008B45' : '',
                  }"
                  >{{ numFormat(scope.row.paidAmountStr) }}</strong
                >
              </template>
            </el-table-column>
            <el-table-column label="支付状态" align="center">
              <template slot-scope="scope">
                <!-- @click="showBillsDialog(scope.row)" -->
                <el-button
                  type="text"
                  @click="showBillsDialog(scope.row)"
                  :disabled="scope.row.payState === '未支付'"
                  >{{ scope.row.payState }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="是否开票" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-if="scope.row.payState == '已支付'"
                  @change="changeItemState(scope.row)(scope.row.id)"
                  v-model="scope.row.invoiceFlag"
                  active-text=""
                  inactive-text=""
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
              prop="upTime"
              width="150px"
              label="更新时间"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" content="人工缴费" placement="top">
                    <!-- <el-button type="success" icon="el-icon-s-finance" circle   @click="showDialog(scope.row)"  
                    :disabled="scope.row.payState == '已支付'"></el-button> -->
                      <el-button  type="text"  @click="showDialog(scope.row)"  
                    :disabled="scope.row.payState == '已支付'">人工缴费</el-button>
                  </el-tooltip> 
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <el-button type="success" icon="el-icon-edit" circle size="mini"  @click="handleEdit(scope.row)"  ></el-button> 
                  </el-tooltip> 
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="缴费明细" name="缴费明细">
          <el-table
            @header-click="headerClickReceipt"
            @sort-change="sortChange"
            height="calc(100vh - 335px)"
            :data="listData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <img
                src="../../assets/list-none.png"
                alt=""
                width="400"
                class="table-empty"
              />
              <div>空荡荡的～暂无数据！</div>
            </template>
            <el-table-column label="付款人姓名"  width="90px" align="center">
              <template slot-scope="scope" v-if="scope.row.payer">
                <el-popover trigger="click" placement="top">
                  <p>证件类型: {{ scope.row.payer.certType }}</p>
                  <p>证件号码: {{ scope.row.payer.certNum }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag style="cursor: pointer" size="medium">{{
                      scope.row.payer.realname
                    }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="payer.phone"  width="110px"  label="电话号码" align="center">
            </el-table-column>
            <el-table-column prop="payType" label="支付方式" align="center">
            </el-table-column>
            <el-table-column
              prop="paidTime"
              label="支付时间"
              width="150px"
              align="center"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column label="支付金额(元)" align="right">
              <template slot-scope="props">
                <strong style="color: #008b45">{{
                  numFormat(props.row.fee / 100)
                }}</strong>
              </template>
            </el-table-column>
            <el-table-column label="账单总金额(元)" align="right">
              <template slot-scope="props">
                <strong>{{ numFormat(props.row.billFee / 100) }}</strong>
              </template>
            </el-table-column>
            <el-table-column
              v-if="!receiptInput"
              prop="receipt"
              width="240px"
              align="center"
              key="receipt_1"
            >
              <template slot="header">
                <div style="color: #409eff">
                  <span>支付凭据 </span>
                  <i class="el-icon-search"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="receiptInput"
              prop="receipt"
              label="支付凭据"
              width="240px"
              align="center"
              key="receipt_2"
            >
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="queryReceipt"
                  size="mini"
                  placeholder="支付凭据"
                  clearable
                  v-focus
                  maxlength="50"
                  @blur="recoverReceipt"
                  @keyup.enter.native="query(0)"
                  @clear="clearInput"
                />
              </template>
              <!-- 
                  autofocus是vue中input的原生属性,element也支持这种方法,
                  但是如果el-input组件外面还有其他组件, 就会导致autofocus失效。
                  解决办法：

                  自定义指令

                  在全局定义一个自动获取焦点的自定义指令，在所有组件中都可以使用v-focus来自动获取焦点。
                  v-focus 是自定义全局指令  
                  参见：https://blog.csdn.net/weixin_46074961/article/details/120350817?spm=1001.2101.3001.6650.1&utm_medium=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1.no_search_link&depth_1-utm_source=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1.no_search_link
                  -->
            </el-table-column>
            <el-table-column prop="comment" label="备注" align="center">
            </el-table-column>
            <el-table-column label="关联账单" align="center">
              <!-- <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="showBillsDialog(scope.row)"
                  :disabled="scope.row.billNum === 0"
                  >{{ scope.row.billNum }}</el-button
                >
              </template> -->
              <!-- 点击此单元格在提示框中显示数据列表 -->
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  content="test"
                  width="400px"
                  trigger="click"
                  :disabled="scope.row.billNum === 0"
                >
                  <el-table :data="scope.row.bills">
                    <el-table-column width="150" label="房源">
                      <template slot-scope="props">
                        <!-- 将单元格显示为按钮状态   （好看） -->
                        <span align="center" style="padding: 5px 5px">
                          <el-button
                            round
                            size="mini"
                            style="cursor: default; padding: 5px 10px"
                          >
                            <div>
                              {{
                                props.row.areaName
                                  ? props.row.areaName +
                                    "：" +
                                    props.row.houseName
                                  : props.row.houseName
                              }}
                            </div>
                          </el-button>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="150"
                      property="pricingName"
                      label="收费项目"
                    ></el-table-column>
                    <el-table-column width="150" label="开始时间">
                      <template slot-scope="props">
                        <span>{{ long2day(props.row.billStart) }}</span>
                        <!-- long2second 是将时间戳转换成时分秒 -->
                        <!-- <span>{{ long2second(props.row.billStart) }}</span> -->
                      </template>
                    </el-table-column>
                    <el-table-column width="150" label="结束时间">
                      <template slot-scope="props">
                        <span>{{ long2day(props.row.billEnd) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="150" label="账单金额(元)">
                      <template slot-scope="scope">
                        <strong>{{
                          numFormat(scope.row.totalAmount / 100)
                        }}</strong>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div slot="reference" class="name-wrapper">
                    <el-tag style="cursor: pointer" size="medium">{{
                      scope.row.billNum
                    }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="是否开票" align="center">
              <template slot-scope="props">
                <el-switch
                  @change="
                    changeOrderState(props.row.invoiceFlag)(props.row.id)
                  "
                  v-model="props.row.invoiceFlag"
                  active-text=""
                  inactive-text=""
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
              prop="upTime"
              width="150px"
              label="更新时间"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="info"
                  icon="el-icon-edit"
                  plain
                  size="mini"
                  @click="editBills(scope.row,'缴费明细')"
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  plain
                  size="mini"
                  @click="deleteItem(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="房源汇总" name="房源汇总">
          <el-table
            height="calc(100vh - 335px)"
            :data="listData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <img
                src="../../assets/list-none.png"
                alt=""
                width="400"
                class="table-empty"
              />
              <div>空荡荡的～暂无数据！</div>
            </template>
            <el-table-column prop="houseName" label="房号" align="center">
            </el-table-column>
            <el-table-column prop="areaName" label="所属区域" align="center">
            </el-table-column>
            <el-table-column label="应收金额(元)" align="right">
              <template slot-scope="scope">
                <span>{{ numFormat(scope.row.totalAmountStr) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收金额(元)" align="right">
              <template slot-scope="scope">
                <strong
                  :style="{
                    color: scope.row.paidAmountStr > 0 ? '#008B45' : '',
                  }"
                  >{{ numFormat(scope.row.paidAmountStr) }}</strong
                >
              </template>
            </el-table-column>
            <el-table-column label="待缴金额(元)" align="right">
              <template slot-scope="scope">
                <span style="color: red">{{
                  numFormat(scope.row.unpaidAmountStr)
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="项目汇总" name="项目汇总">
          <el-table
            height="calc(100vh - 335px)"
            :data="listData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <img
                src="../../assets/list-none.png"
                alt=""
                width="400"
                class="table-empty"
              />
              <div>空荡荡的～暂无数据！</div>
            </template>
            <el-table-column prop="type" label="项目类型" align="center">
            </el-table-column>
            <el-table-column prop="name" label="项目名称" align="center">
            </el-table-column>
            <el-table-column label="应收金额(元)" align="right">
              <template slot-scope="scope">
                <span>{{ numFormat(scope.row.totalAmountStr) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收金额(元)" align="right">
              <template slot-scope="scope">
                <strong
                  :style="{
                    color: scope.row.paidAmountStr > 0 ? '#008B45' : '',
                  }"
                  >{{ numFormat(scope.row.paidAmountStr) }}</strong
                >
              </template>
            </el-table-column>
            <el-table-column label="待缴金额(元)" align="right">
              <template slot-scope="scope">
                <span style="color: red">{{  numFormat(scope.row.unpaidAmountStr) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>
    <!-- 人工缴费  -->
    <el-dialog
      :visible.sync="payTogetherVisible"
      :title="titleName"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="payTogetherClose"
    >
      <div class="div-2" style="margin-top: 15px">
        <div>
          <div class="div-3-title">
            应收总金额：<span style="color: #1296db">{{
              numFormat(this.totalAmount / 100)
            }}</span>
          </div>
        </div>
        <div>
          <div class="div-3-title">
            实收总金额：
            <span style="color: #008b45">{{
              numFormat(this.paidAmount / 100)
            }}</span>
          </div>
        </div>
        <div >
          <div class="div-3-title" >待缴总金额： <span style="color: red;">{{numFormat(this.arrearageAmount/100)}}</span></div>
        </div>
      </div>
      <el-table
        :data="billList"
        style="width: 100%"
        max-height="275"
        border
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column label="房源" width="190px" align="center">
          <template slot-scope="props">
            <span align="center" style="padding: 5px 5px">
              <el-button
                round
                size="mini"
                style="cursor: default; padding: 5px 10px"
              >
                <div>
                  {{
                    props.row.areaName
                      ? props.row.areaName + "：" + props.row.houseName
                      : props.row.houseName
                  }}
                </div>
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="billStartStr" label="开始时间" align="center">
        </el-table-column>
        <el-table-column prop="billEndStr" label="结束时间" align="center">
        </el-table-column>
        <el-table-column prop="pricingName" label="收费项目" align="center">
        </el-table-column>
        <el-table-column label="应收金额(元)" align="right">
          <template slot-scope="scope">
            <strong>{{ numFormat(scope.row.totalAmountStr) }}</strong>
          </template>
        </el-table-column>
        <el-table-column label="实收金额(元)" align="right">
          <template slot-scope="scope">
            <strong
              :style="{
                color: scope.row.paidAmountStr > 0 ? '#008B45' : '',
              }"
              >{{ numFormat(scope.row.paidAmountStr) }}</strong
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="div-2" style="margin-top: 15px">
        <div class="div-2">
          <div class="div-2-title">付款人姓名</div>
          <el-input v-model="formInput.payerName"></el-input>
        </div>
        <div class="div-2">
          <div class="div-2-title">付款人手机号</div>
          <el-input v-model="formInput.payerPhone"></el-input>
        </div>
      </div>
      <div class="div-2" style="margin-top: 15px">
        <div class="div-2">
          <div class="div-2-title">支付金额（元）</div>
          <div slot="reference" class="name-wrapper">
            <el-input-number
              v-model="formInput.paidAmount"
              style="width: 100%"
              :precision="2"
              :min="0"
            ></el-input-number>
          </div>
        </div>
        <div class="div-2">
          <div class="div-2-title">支付方式</div>
          <el-select
            v-model="formInput.payType"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="微信" value="微信"></el-option>
            <el-option label="支付宝" value="支付宝"></el-option>
            <el-option label="银行对公账户" value="银行对公账户"></el-option>
            <el-option label="银行个人账户" value="银行个人账户"></el-option>
            <el-option label="现金" value="现金"></el-option>
            <el-option label="其它" value="其它"></el-option>
          </el-select>
        </div>
      </div>
      <div class="div-2" style="margin-top: 15px">
        <div class="div-2">
          <div class="div-2-title">支付凭据</div>
          <el-input v-model="formInput.receipt"></el-input>
        </div>
        <div class="div-2">
          <div class="div-2-title">备注</div>
          <el-input v-model="formInput.comment"></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closePayTogether" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitAdd()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      width="30%"
      :visible.sync="dialogBillQR"
      title="付款二维码"
      :before-close="uploadClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <img :src="billQR" alt="" />
      <div style="color: red">请使用微信扫描支付</div>
      <div>{{ leftTimeStr }} 后失效</div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogUploadVisible"
      :before-close="uploadClose"
      title="批量导入数据"
      width="50%"
    >
      <file-upload type="付款信息导入"  :orgID="uploadOrgID" :file="dialogUploadFile"></file-upload>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogBillsVisible"
      title="缴费明细"
      width="90%"
      :before-close="billsUploadClose"
    >
      <el-table
        :data="dialogBillsList"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column label="付款人姓名"  width="90px"  align="center">
          <!-- <template slot-scope="props">
            <span>{{ props.row.payer.realname }}</span>
          </template> -->
          <template slot-scope="scope" v-if="scope.row.payer">
            <el-popover trigger="click" placement="top">
              <p>证件类型: {{ scope.row.payer.certType }}</p>
              <p>证件号码: {{ scope.row.payer.certNum }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag style="cursor: pointer" size="medium">{{
                  scope.row.payer.realname
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column  width="110px" label="电话号码" align="center">
          <template slot-scope="props">
            <span>{{ props.row.payer.phone }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="证件类型" align="center">
          <template slot-scope="props">
            <span>{{ props.row.payer.certType }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证件号码" align="center">
          <template slot-scope="props">
            <span>{{ props.row.payer.certNum }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="支付方式" align="center">
          <template slot-scope="props">
            <span>{{ props.row.payType }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" width="150px" align="center">
          <template slot-scope="props">
            <span>{{ long2second(props.row.paidTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额(元)" align="center">
          <template slot-scope="scope">
            <strong style="color: #008b45">{{
              numFormat(scope.row.fee / 100)
            }}</strong>
          </template>
        </el-table-column>
        <el-table-column label="支付凭据" width="240px" align="center">
          <template slot-scope="props">
            <span>{{ props.row.receipt }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="400px" align="center">
          <template slot-scope="props">
            <span>{{ props.row.comment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否开票" align="center">
          <template slot-scope="scope">
            <el-switch
              @change="changeOrderState(scope.row.invoiceFlag)(scope.row.id)"
              v-model="scope.row.invoiceFlag"
              active-text=""
              inactive-text=""
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px" align="center">
          <template slot-scope="scope">
            <!-- <el-button
              type="info"
              icon="el-icon-edit"
              plain
              size="mini"
              @click="editBills(scope.row,'账单明细')"
            ></el-button> -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              plain
              size="mini"
              @click="deleteItem(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 编辑的弹框 --> 
      <el-dialog :title="'【'+editForm.areaName+':'+editForm.houseName+'】 编辑'" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <div v-loading="viewLoading">
          <el-form ref="form" :model="editForm" label-width="100px">
             <el-form-item label="承租人">
               <div style="text-align:left">{{editForm.renters[0].nickname}}</div>
                <!-- <el-input v-model="editForm.renters[0].nickname" disabled></el-input> -->
              </el-form-item>
               <el-form-item label="收费项目">
                 <div style="text-align:left">{{editForm.pricingName}}</div>
                <!-- <el-input v-model="editForm.pricingName" disabled></el-input> -->
              </el-form-item>
              <el-form-item label="账单时间">
                <div style="text-align:left">{{editForm.billStart}} 至 {{editForm.billEnd}}</div>
                <!-- <el-input v-model="editForm.pricingName" disabled></el-input> -->
              </el-form-item>
              <el-form-item label="账单总金额">
                <el-input v-model="editForm.totalAmount"></el-input>
              </el-form-item>
               <el-form-item label="备注">
                <el-input v-model="editForm.comment"></el-input>
              </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="preview">预 览</el-button>
        </span>
      </el-dialog>
      <!-- 预览的弹框 --> 
      <el-dialog :title="'【'+editForm.areaName+':'+editForm.houseName+'】预览'" :visible.sync="previewVisible" width="50%" :before-close="handleClose1">
        <div v-loading="viewLoading1">
          <div class="itemBox">
            <div style="width:120px;margin-right:15px;color:#999">收费项目:</div>
            <div>{{editData.pricingName}}</div>
          </div>
          <div class="itemBox">
            <div style="width:120px;margin-right:15px;color:#999">账单时间:</div>
            <div>{{editData.billStart}} 至 {{editData.billEnd}}</div>
          </div> 
          <div class="itemBox">
            <div style="width:120px;margin-right:15px;color:#999">应收金额:</div>
            <div>{{ editData.totalAmount.oldValue?numFormat(editData.totalAmount.oldValue/100):0}} </div> 
            <div style="margin:0 10px"><i class="el-icon-right"></i></div>
            <div style="color:red">{{ editData.totalAmount.newValue?numFormat(editData.totalAmount.newValue/100):0}} </div> 
            <div style="color:red;margin-left:30px"> {{ editData.totalAmount.comment }}  </div>
          </div>  
 
          <div class="itemBox">
            <div style="width:120px;margin-right:15px;color:#999"> 实收金额:</div>
            <div>{{ editData.paidAmount.oldValue?numFormat(editData.paidAmount.oldValue/100):0}} </div>
             <div style="margin:0 10px"><i class="el-icon-right"></i></div>
            <div style="color:red">{{ editData.paidAmount.newValue?numFormat(editData.paidAmount.newValue/100):0}} </div> 
            <div style="color:red;margin-left:30px"> {{editData.paidAmount.comment}} </div>
          </div>  
          <div class="itemBox">
            <div style="width:120px;margin-right:15px;color:#999"> 备注:</div>
            <div>{{ editData.comment.oldValue||'无'}} </div>
            <div style="margin:0 10px"><i class="el-icon-right"></i></div>
            <div style="color:red">{{editData.comment.newValue}} </div>
          </div>  
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="previewVisible = false">取 消</el-button>
          <el-button type="primary" @click="previewSubmit">确认</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import { Decimal } from "decimal.js";
import FileUpload from "./FileUpload";
import mixins from "../../minix";
let _vue;
import countTo from "vue-count-to";

let interval;

export default {
  name: "home",

  mixins: [mixins],

  components: { FileUpload, countTo },

  data() {
    return {
      uploadOrgID:"",//上传文件需要传递的组织id参数uploadOrgID
      rgState: false,//是否点击人工缴费按钮显示的缴费页面
      totalAmount: "", //应收总金额
      paidAmount: "", //实收总金额
      arrearageAmount: "", //需缴费总金额
      receiptInput: false,
      viewLoading:false,
      viewLoading1:false,
      editData:{
        totalAmount:{
          isModified:false
        },
        paidAmount:{},
        comment:{}

      },
      timeSort: "",
      contractStates: [],
      daterange: this.defaultDateRange(),
      daterangePaid: "",
      payTogetherVisible: false,
      previewVisible:false,
      dialogVisible:false,
      editForm:{
        renters:[{
          nickname:''
        }],
      },
      formInput: {},
      titleName:'人工缴费',
      pageIdx: 0,
      itemTotal: 0,
      listData: [],
      stateList: ["全部状态", "已支付", "未支付", "欠费"],
      state: "全部状态",
      houseNameRegex: "",
      areaIDSelect: ["全部区域"],
      pricingTypes: ["分期", "一次性", "按量"],

      queryPricing: [],
      pricingList: [],

      billIdList: [],
      billList: [],
      billQR: "",
      dialogBillQR: false,

      dialogUploadVisible: false,
      dialogUploadFile: "",

      dialogBillsVisible: false,
      dialogBillsList: [],
      dialogBillsData: {},

      leftTimeStr: "",

      queryType: "账单明细",
      exportType: ["明细", "汇总"],

      nameOrPhone: "", // 根据姓名或手机号模糊查询

      queryReceipt: "", // 支付凭据查询

      statistics: {
        total: 0, // 应收金额
        paid: 0, // 实收金额
        unpaid: 0, // 欠款金额
      }, // 统计数据

      areaProps: {
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          let superAreaID = "";
          if (node.level > 0) {
            superAreaID = node.data.value;
          }
          let list = await _vue.areasQuery(superAreaID);
          let resolveData = [];
          if (list) { 
            list.forEach((item) => {
              resolveData.push({
                value: item.id,
                label: item.name,
              });
            });
          }
          if (node.level === 0) {
            resolveData.unshift({
              value: "全部区域",
              label: "全部区域",
            });
          }
          resolve(resolveData);
        },
      },
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.query(0);
    this.queryPricings();

    _vue = this;
  },

  watch: {
    queryPricing() {
      this.initQuery();
    },
    state() {
      this.initQuery();
    },

    areaIDSelect() {
      this.initQuery();
    },

    pricingTypes() {
      this.initQuery();
    },

    daterange() {
      this.initQuery();
    },

    daterangePaid() {
      this.initQuery();
    },

    queryType() {
      this.initQuery();
    },
  },

  methods: {
    // 默认的时段：本月
    defaultDateRange() {
      let now = new Date();
      let mStart = new Date(now.getFullYear(), now.getMonth(), 1);
      let mEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return [mStart, mEnd];
    },
    billsUploadClose(){
      if (this.queryType== "账单明细"){
        this.titleName="人工缴费"
      }
      this.dialogBillsVisible=false
    },
    closePayTogether(){
      
      // this.billIdList=(this.rgState==true?[]:this.billIdList
     if (this.rgState){
      this.rgState = false
      this.$refs.payRef.clearSelection();
      this.billIdList=[]
      }

      this.payTogetherVisible = false

    } ,
    payTogetherClose(done) {
      // 如果先点击人工缴费  关闭时将billIDList置空 （处理点击人工缴费后未选择数据也能点击合并缴费功能的bug）
      if (this.rgState){
      this.rgState = false
      this.$refs.payRef.clearSelection();
      this.billIdList=[]
      }
      done()

    },
    deleteItem(item) {
      let _vue = this;
      this.$confirm(`是否删除该笔支付？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });

        axios({
          method: "post",
          url: "porders/delete",
          data: {
            orderID: item.id,
          },
        }).then((value) => {
          if (value.data.code === 0) {
            this.dialogBillsVisible = false;
            _vue.$message.success(value.data.message);
            _vue.query(_vue.pageIdx - 1);
          } else {
            _vue.$message.error(value.data.message);
          }
        }).finally(()=>{
          loading.close();
        });
      });
    },
    payTogether() {
      if (this.billIdList.length > 0) {
        this.payTogetherVisible = true;
      } else {
        this.$message.error("请先选择需要支付的账单");
      }
      // this.formInput=[]
    },
    clearInput() {
      this.receiptInput = false;
      this.query(0);
    },
    recoverReceipt(event) {
      if (!this.queryReceipt) {
        this.receiptInput = false;
      }
    },
    headerClickReceipt(column, event) {
      if (column.property == "receipt") {
        this.receiptInput = true;
      }
    },
    sortChange(e) {
      this.timeSort = e.order;
      this.pageIdx = 0;
      this.query(0);
    },
    async showDialogUpload() {
      this.uploadOrgID = this.$route.query.orgID
      let data = this.getParams(0);
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      await axios({
        method: "post",
        url: "bills/cmtpl/generate",
        data: data,
      })
        .then((value) => {
          if (value.data.code === 0) {
            this.dialogUploadFile = value.data.data;
            this.dialogUploadVisible = true;
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },

    handleCurrentChange(val) {
      this.pageIdx = val;
      this.query(val - 1);
    },

    uploadClose(done) {
      this.leftTimeStr = "";
      clearInterval(interval);
      this.pageIdx = 0;
      this.query(0);
      done();
    },

    async areasQuery(superAreaID) {
      let returnData = [];
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      await axios({
        method: "post",
        url: "areas/query",
        data: {
          pageIdx: 0,
          pageSize: 100,
          superAreaID: superAreaID,
        },
      })
        .then((value) => {
          returnData = value.data.data;
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
      return returnData;
    },

    handleSizeChange(val) {
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },
    submitAdd() {
      if (!this.formInput.payerName || this.formInput.payerName.length <= 0) {
        this.$message.error("请输入付款人姓名");
        return;
      }
      if (!this.formInput.payerPhone || this.formInput.payerPhone.length <= 0) {
        this.$message.error("请输入付款人电话");
        return;
      }
      if (!this.formInput.paidAmount || this.formInput.paidAmount <= 0) {
        this.$message.error("请输入付款金额");
        return;
      }
      if (!this.formInput.payType || this.formInput.payType.length <= 0) {
        this.$message.error("请选择支付方式");
        return;
      }
      let data = {}
      let url =""
      if (this.titleName=="人工缴费"){
        data = { ...this.formInput };
        url="bills/manhandle"
        data.paidAmount = new Decimal(this.formInput.paidAmount)
        .mul(new Decimal(100))
        .toNumber();
        data.billIDs = this.billIdList;

      }else if (this.titleName=="编辑订单"){
        data={
          orderID:  this.formInput.id,
          payerName: this.formInput.payerName,
          payerPhone: this.formInput.payerPhone,
          payType: this.formInput.payType,
          fee: this.formInput.paidAmount*100,
          receipt: this.formInput.receipt,
          comment: this.formInput.comment,
          orgID:this.$route.query.orgID ,
        }
        url="porders/edit"
      }
      
      
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      axios({
        method: "post",
        url: url,
        data: data,
      })
        .then((value) => {
          if (value.data.code == 0) {
            this.$message.success(value.data.message);
            this.payTogetherVisible = false;
            this.dialogBillsVisible = false
            this.closePayTogether()
            this.query(this.pageIdx - 1);
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },

    showDialog(item) {
        this.rgState = true
        this.titleName="人工缴费"
      // handleSelectionChange方法中参数是数组  所以下方要使用数组传参
      this.handleSelectionChange([item]);
      this.payTogether();
    },
    // 编辑按钮
    handleEdit(e){  
        this.dialogVisible = true  
        this.editForm = {...e}; 
        console.log(e)
        this.editForm.totalAmount = this.editForm.totalAmount/100
         this.editForm.billStart = Utils.long2day(this.editForm.billStart * 1000)
        this.editForm.billEnd = Utils.long2day(this.editForm.billEnd * 1000)
        this.totalAmountVal = this.editForm.totalAmount 
        this.commentVal = this.editForm.comment; 
    },
    // 关闭编辑弹框
    handleClose(){
      this.dialogVisible = false 
    },
     handleClose1(){
      this.previewVisible = false 
    },
    // 预览按钮
    preview(){ 
       if(this.totalAmountVal != this.editForm.totalAmount){
         if(this.commentVal == this.editForm.comment){
           return this.$message.error("修改了金额，则必须填写备注")
         }
       } 
        this.billsEdit(true)
    },
    previewSubmit(){
         this.billsEdit(false)
    },
    // 编辑账单的接口
    billsEdit(e){
         let data={
        id:this.editForm.id, 
        totalAmount:this.editForm.totalAmount*100,
        comment:this.editForm.comment,
        orgID:this.$route.query.orgID,
        preivew:e
      }
      if(e){
          this.viewLoading = true; 
      }else{
        this.viewLoading1 = true; 
      } 
      let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
      axios({
        method: "post",
        url: `${v2BaseURL}bills/edit`,
        data:data,
      }).then((res) => {
        if(res.data.code==0){
          if(res.data.data){
            this.editData = {...res.data.data};
            this.editData.billStart = Utils.long2day(this.editData.billStart * 1000)
            this.editData.billEnd = Utils.long2day(this.editData.billEnd * 1000)
            this.previewVisible = true;
          }else{
            this.$message.success('编辑成功！')
            this.previewVisible = false;
            this.dialogVisible = false;
            this.query(0)
          }
        }
         
      }) .catch(() => {

      }).finally(()=>{
        this.viewLoading=false;
        this.viewLoading1=false;
      });
    },
    editBills(row,state) {
      this.titleName="编辑订单"
      this.rgState = true
      let billsData ={}
      if (state=="缴费明细"){
        let billsDataT=[] 
            row.bills.forEach((item) => {
            item.billStartStr = Utils.long2day(item.billStart * 1000);
            item.billEndStr = Utils.long2day(item.billEnd * 1000);
            item.paidAmountStr = item.paidAmount / 100;
            item.unpaidAmountStr = item.unpaidAmount / 100;
            item.totalAmountStr = item.totalAmount / 100;
            billsDataT.push(item);
          });

          billsData.bills=billsDataT
          billsData.orders=[row]
      }else if(state=="账单明细"){
        billsData.bills=[this.dialogBillsData]
        billsData.orders=[row]
      }
      // this.handleSelectionChange([billsData]);
      

        this.formInput = [];
        this.billIdList = [];
        this.billList = [];
        // 应收总额
        this.totalAmount = 0;
        // 实收总额
        this.paidAmount = 0;
        // 欠费总额
        this.arrearageAmount = 0; 
       billsData.bills.forEach((item) => {
            this.totalAmount += item.totalAmount;
            this.paidAmount += item.paidAmount;
            item.show = false;
            this.billIdList.push(item.id);
            this.billList.push(item);
          });
          this.arrearageAmount = this.totalAmount - this.paidAmount;

          this.$set(this.formInput, "id", row.id);
          this.$set(this.formInput, "paidAmount", row.fee / 100);
          this.$set(this.formInput, "payerName", row.payer.realname);
          this.$set(this.formInput, "payerPhone", row.payer.phone);
          this.$set(this.formInput, "payType", row.payType);
          this.$set(this.formInput, "receipt", row.receipt);
          this.$set(this.formInput, "comment", row.comment);
      this.payTogether();
    },

    showBillsDialog(item) {
      this.dialogBillsList = item.orders || [];
      this.dialogBillsData = item;
      this.dialogBillsVisible = true;
    },

    showQR() {
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "bills/qrcode",
        data: {
          billIDs: this.billIdList,
        },
      }).then((value) => {
          this.billQR = "data:image/png;base64," + value.data.data.qrcode;
          this.dialogBillQR = true;

          let endTime = value.data.data.expiredAt * 1000;

          let _vue = this;

          let leftTime = endTime - new Date().getTime();

          let minutes = parseInt((leftTime / 1000 / 60) % 60);
          let seconds = parseInt((leftTime / 1000) % 60);
          _vue.leftTimeStr =
            _vue.checkTime(minutes) + ":" + _vue.checkTime(seconds);

          interval = setInterval(function () {
            let leftTime = endTime - new Date().getTime();

            if (leftTime <= 0) {
              clearInterval(interval);
              _vue.initQuery();
              _vue.dialogBillQR = false;
            }
            let minutes = parseInt((leftTime / 1000 / 60) % 60);
            let seconds = parseInt((leftTime / 1000) % 60);
            _vue.leftTimeStr =
              _vue.checkTime(minutes) + ":" + _vue.checkTime(seconds);
          }, 1000);
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },

    checkTime(i) {
      if (i < 10) {
        return "0" + i;
      }
      return i;
    },

    handleSelectionChange(val) {
      if(val.length>0){
        this.formInput = [];
        this.billIdList = [];
        this.billList = [];
        // 应收总额
        this.totalAmount = 0;
        // 实收总额
        this.paidAmount = 0;
        // 欠费总额
        this.arrearageAmount = 0; 
        val.forEach((item) => {
          this.totalAmount += item.totalAmount;
          this.paidAmount += item.paidAmount;
          item.show = false;
          this.billIdList.push(item.id);
          this.billList.push(item);
        });
        this.arrearageAmount = this.totalAmount - this.paidAmount;

        this.$set(this.formInput, "paidAmount", this.arrearageAmount / 100);
        this.$set(this.formInput, "payerName", val[0].renters[0].realname);
        this.$set(this.formInput, "payerPhone", val[0].renters[0].phone);
      }
    },

    handleSelection(row) {
      return row.payState != "已支付";
    },

    initQuery() {
      if (this.queryType== "账单明细"){
        this.titleName="人工缴费"
      }
      this.pageIdx = 0;
      this.query(0);
    },

    queryPricings() {
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "pricings/query",
        data: {
          pageIdx: 0,
          pageSize: this.pageSize,
        },
      })
        .then((value) => {
          this.pricingList = []; 
          value.data.data.forEach((item) => {
            this.pricingList.push({
              id: item.id,
              name: item.name,
              value: item.name,
            });
          }); 
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },

    //导出报表
    async electricityBillExport() {
      let data = this.getParams(0);
      let file = "";
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      await axios({
        method: "post",
        url: "electricity/report",
        data: {
          start: data.start,
          end: data.end,
          orgID: data.orgID,
        },
      })
        .then((value) => {
          if (value.data.code != 0) {
            loading.close();
            this.$message.error(value.data.message);
          } else {
            file = value.data.data;
          }
        })
        .catch(() => {});

      if (file === "") return; // 没有获取到文件名时，不启动下载
      let baseURL = axios.defaults.baseURL.replace("/v1/org", "");
      await axios({
        method: "get",
        url: `${baseURL}public/${file}`,
        responseType: "blob",
      })
        .then((value) => {
          Utils.convertRes2Blob(file, value);
          this.$message.success("文件下载成功");
        })
        .catch((e) => {
          this.$message.error(e.toString());
        })
        .finally(() => {
          loading.close();
        });
    },

    //导出报表
    async exportFile() {
      let data = this.getParams(0);
      data.exportType = ["明细", "汇总"];
      // if (!Array.isArray(this.exportType) || this.exportType.length === 0) {
      //   this.$message.error("请选择导出内容：明细、汇总");
      //   return;
      // }
      // let data = {
      //   houseNameRegex: this.houseNameRegex,
      //   state: this.state,
      //   pricingTypes: this.pricingTypes,
      //   exportType: this.exportType,
      //   pageSize: this.pageSize,
      // };

      // if (Array.isArray(this.daterange)) {
      //   data.start = parseInt(this.daterange[0].getTime() / 1000);
      //   data.end = parseInt(
      //     this.daterange[1].getTime() / 1000 + 60 * 60 * 24 - 1
      //   );
      // }
      // if (Array.isArray(this.daterangePaid)) {
      //   data.paidStart = parseInt(this.daterangePaid[0].getTime() / 1000);
      //   data.paidEnd = parseInt(
      //     this.daterangePaid[1].getTime() / 1000 + 60 * 60 * 24 - 1
      //   );
      // }
      // if (!data.start && !data.paidStart) {
      //   this.$message.error("请先选择账单时段或支付时段");
      //   return;
      // }

      // if (this.areaIDSelect.length > 0) {
      //   data.areaID = this.areaIDSelect[this.areaIDSelect.length - 1];
      // }

      let file = "";

      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      await axios({
        method: "post",
        url: "bills/export",
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            loading.close();
            this.$message.error(value.data.message);
          } else {
            file = value.data.data;
          }
        })
        .catch(() => {});

      if (file === "") return; // 没有获取到文件名时，不启动下载

      let baseURL = axios.defaults.baseURL.replace("/v1/org", "");

      await axios({
        method: "get",
        url: `${baseURL}public/${file}`,
        responseType: "blob",
      })
        .then((value) => {
          Utils.convertRes2Blob(file, value);
          this.$message.success("文件下载成功");
        })
        .catch((e) => {
          this.$message.error(e.toString());
        })
        .finally(() => {
          loading.close();
        });
    },

    getParams(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }
      let data = {
        pricingTypes: this.pricingTypes,
        houseNameRegex: this.houseNameRegex,
        pricingName: this.queryPricing, // 若未选，默认全部
        nameOrPhone: this.nameOrPhone,
        state: this.state,
        pageSize: this.pageSize,
        queryType: this.queryType,
        pageIdx: pageIdx,
        receipt: this.queryReceipt,
        timeSort: this.timeSort, //开始时间排序方式
      };

      if (Array.isArray(this.daterange)) {
        data.start = parseInt(this.daterange[0].getTime() / 1000);
        data.end = parseInt(
          this.daterange[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      }

      if (Array.isArray(this.daterangePaid)) {
        data.paidStart = parseInt(this.daterangePaid[0].getTime() / 1000);
        data.paidEnd = parseInt(
          this.daterangePaid[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      }

      if (this.areaIDSelect.length > 0) {
        data.areaID = this.areaIDSelect[this.areaIDSelect.length - 1];
      }

      // 状态选择欠费时，账单时间筛选的结束时间使用当前时间
      if (data.state == "欠费") {
        let curr = parseInt(new Date().getTime() / 1000);
        if (!data.end || data.end == 0 || data.end > curr) {
          data.end = curr;
        }
      }

      return data;
    },

    //列表查询
    query(pageIdx) {
      let data = this.getParams(pageIdx);

      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      // 查询列表数据
      this.listData = []; // 清空数据

      let v2BaseURL = axios.defaults.baseURL.replace("/v1", "/v2"); // 使用v2版本接口
      axios({
        method: "post",
        url: `${v2BaseURL}bills`,
        data: data,
      })
        .then((value) => {
          if (value.data.code != 0) {
            loading.close();
            this.$message.error(value.data.message);
            return;
          }
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            if (this.queryType == "项目汇总") {
              value.data.data = value.data.data.pricings;
            } 
            value.data.data.forEach((item) => {
              item.upTime = Utils.long2second(item.upTime * 1000);
              // item.billStart = Utils.long2day(item.billStart * 1000);
              // item.billEnd = Utils.long2day(item.billEnd * 1000);
              
            item.billStartStr = Utils.long2day(item.billStart * 1000);
            item.billEndStr = Utils.long2day(item.billEnd * 1000);
              item.paidTime = Utils.long2second(item.paidTime * 1000);
              item.paidAmountStr = item.paidAmount / 100;
              item.unpaidAmountStr = item.unpaidAmount / 100;
              item.totalAmountStr = item.totalAmount / 100;
              this.listData.push(item);
            });
          }
        })
        .catch((e) => {
          console.error(e); // 打印异常
        })
        .finally(() => {
          loading.close();
        });

      // 查询汇算数据
      this.statistics = {
        total: 0,
        paid: 0,
        unpaid: 0,
      };

      let baseURL = axios.defaults.baseURL.replace("/org", "");
      axios({
        method: "post",
        url: `${baseURL}settle`,
        data: data,
      })
        .then((value) => {
          this.statistics = {
            total: value.data.data.totalAmount,
            paid: value.data.data.paidAmount,
            unpaid: value.data.data.unpaidAmount,
          };
        })
        .catch((e) => {
          console.error(e); // 打印异常
        })
        .finally(() => {
          loading.close();
        });
    },

    changeItemState(row) {
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      let _vue = this;
      return (billID) => {
        axios({
          method: "post",
          url: "bills/invoices/mark",
          data: {
            billID: billID,
            invoiceFlag: row.invoiceFlag,
          },
        })
          .then((value) => {
            if (value.data.code != 0) {
              this.$message.error(value.data.message);
              row.invoiceFlag = !row.invoiceFlag;
              return;
            } else {
              this.$message.success(value.data.message);
              _vue.query(_vue.pageIdx - 1);
            }
          })
          .catch((_) => {})
          .finally(()=>{
            loading.close();
          });
      };
    },

    changeOrderState(state) {
      let _vue = this;
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      return (orderID) => {
        axios({
          method: "post",
          url: "orders/invoices/mark",
          data: {
            orderID: orderID,
            invoiceFlag: state,
          },
        })
          .then((value) => {
            if (value.data.code != 0) {
              this.$message.error(value.data.message);
              return;
            } else {
              this.$message.success(value.data.message);
              _vue.query(_vue.pageIdx - 1);
            }
          })
          .catch((_) => {})
          .finally((_) => {
            loading.close();
            _vue.query(_vue.pageIdx - 1);
          });
      };
    },

    long2day(time) {
      return Utils.long2day(time * 1000);
    },
    long2second(time) {
      return Utils.long2second(time * 1000);
    },
  },
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.header-title {
  text-align: end;
  width: 150px;
  // margin-right: 15px;
}
.div-title {
  width: 130px;
}
.div-3-title {
  text-align: left;
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  margin-right: 15px;
  color: #606266;
  font-size: 15px;
}
.div-export {
  position: absolute;
  top: 225px;
  right: 20px;
}
#myChart {
  position: absolute;
  top: 12px;
  right: 20px;
}
.itemBox{
  display: flex;
  margin: 10px 0;
  text-align: right;
  line-height: 20px;
}
.classBox{
  border: 1px solid #ccc;
  margin-top: 20px;
  padding: 10px;
  padding-bottom: 0px;
}
.classBoxTitle{ 
  // border: 1px solid #ccc;
  width: 60px;
  text-align: center;
  background-color: #fff;
  margin-top: -20px;
  color: green;
  font-weight: 600;
}
</style>
